import { useState } from 'react';

import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import { excelDownLoad } from '../../../../../lib/common';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/account/user/models';
import { CS_QNA_LIST_SORT_OPTION_MODEL } from '../../../../../store/modules/cs/qna/models';
import { useAccountUserCsQnaDetailQuery, useAccountUserDetailCsQnaListExcelDownloadMutate } from './query';
import { getTablePages } from '../../../../../lib/utils/tableUtils';

export const useAccountUserCsQnaDetail = ({ userId, isActive }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [sortOption, setSortOption] = useState(CS_QNA_LIST_SORT_OPTION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL);

  const { data } = useAccountUserCsQnaDetailQuery({
    userId,
    pagination,
    filterOption,
    sortOption,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_CS_QNA_DETAIL_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        list: result.data.csQnaList.list,
        totalCnt: result.data.csQnaList.totalCnt,
      }),
    },
  });

  const { mutateAsync } = useAccountUserDetailCsQnaListExcelDownloadMutate();

  const downloadUserDetailCsQnaListExcel = async () => {
    try {
      const result = await mutateAsync({
        userId,
        csQnaHistory: {
          filterOption,
          sortOption,
          pagination,
        },
      });

      toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad('유저 상세 상품 문의 리스트', result.data.csQnaListExcelSheet);
    } catch (error) {
      toastMsg.error(error.message);
    }
  };

  const getList = ({ filterOption, pagination, sortOption }) => {
    filterOption && setFilterOption(filterOption);
    pagination && setPagination(pagination);
    sortOption && setSortOption(sortOption);
  };

  return {
    csQnaList: data,
    getList,
    downloadUserDetailCsQnaListExcel,
    pagination: { ...pagination, pages: getTablePages(data.totalCnt, pagination.pageSize) },
    sortOption,
    filterOption,
  };
};
